// extracted by mini-css-extract-plugin
export default {"root":"klHMFm5iarVbsI1bDsJA","skipLeftPadding":"jnt_xk67ayoEHoaeAF94","skipPadding":"Yw2vrBkBap8PRC4B_2Xo","placeHolderShimmer":"psevq3kozK5oDlOWSldN"};